import { useMemo } from 'react';
import { ClaimContextFiles } from '../types';

export function useDocumentViewerFiles(claim: ClaimContextFiles) {
  return useMemo(
    () => [
      ...(claim.invoiceDocuments || []), // we put invoiceDocuments first so we open it by default
      ...(claim.trackingScreenshot || []),
      ...(claim.declarationOfRecipient || []),
      ...(claim.picturesOfDamage || []),
      ...(claim.picturesOfMissingItem || []),
      ...(claim.proofOfConsumerPayment || []),
      ...(claim.additionalDocuments || []),
      ...(claim.carrierDamageReport || []),
      ...(claim.deadlineSupportingDocuments || []),
    ],
    [
      claim.invoiceDocuments,
      claim.trackingScreenshot,
      claim.declarationOfRecipient,
      claim.picturesOfDamage,
      claim.picturesOfMissingItem,
      claim.proofOfConsumerPayment,
      claim.additionalDocuments,
      claim.carrierDamageReport,
      claim.deadlineSupportingDocuments,
    ]
  );
}
